import React from "react";
import { Text, Stack, Switcher, Box, CashSmallIcon } from "@thecb/components";
import { SEMI_BOLD } from "@/constants/fonts";

const Cash = () => {
  return (
    <Stack childGap="0.5rem">
      <Switcher
        breakpoint="700px"
        childGap="0.25rem"
        largeChild={2}
        largeChildSize={5}
      >
        <Text variant="pS" weight={SEMI_BOLD} extraStyles="flex-basis: 17rem;">
          Payment method
        </Text>
        <Box padding="0" extraStyles="display: flex; align-items: center;">
          <CashSmallIcon />
          <Text variant="pS" extraStyles="padding-left: 0.5rem;">
            Cash
          </Text>
        </Box>
      </Switcher>
    </Stack>
  );
};

export default Cash;
